import { Skeleton, Stack } from "@mui/material";

export function ListRowSkeleton() {
  return (
    <Stack
      direction="row"
      spacing={1.5}
      data-testid="list-row-skeleton"
      sx={{ alignItems: "center", px: 1, py: 1.5 }}
    >
      <Skeleton variant="circular" width={44} height={44} aria-hidden />
      <Stack spacing={0.75} aria-hidden sx={{ flex: 1 }}>
        <Skeleton width="44%" />
        <Skeleton width="66%" />
      </Stack>
    </Stack>
  );
}
